export const items = [
  {
    sys: { id: 0 },

    fields: {
      title: "Apple iphone - 11",
      price: 90000,
      company: "Apple",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: true,

      image: { fields: { file: { url: "img/product-1.png" } } }
    }
  },
  {
    sys: { id: 1 },
    fields: {
      title: "google pixel - black",
      price: 27000,
      company: "google",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: true,
      image: { fields: { file: { url: "img/product-01.png" } } }
    }
  },
  {
    sys: { id: 2 },

    fields: {
      title: "Macbook Pro",
      price: 120000,
      company: "Apple",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: true,

      image: { fields: { file: { url: "img/product-6.jpg" } } }
    }
  },
  {
    sys: { id: 3 },

    fields: {
      title: "Macbook Air",
      price: 64000,
      company: "Apple",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-9.png" } } }
    }
  },
  
  
  {
    sys: { id: 4 },

    fields: {
      title: "iphone 7",
      price: 38000,
      company: "Apple",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-4.png" } } }
    }
  },
  {
    sys: { id: 5 },

    fields: {
      title: "samsung galaxy A8 - black",
      price: 17000,
      company: "samsung",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-5.png" } } }
    }
  },
  {
    sys: { id: 6 },

    fields: {
      title: "htc 10 - black",
      price: 21000,
      company: "htc",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-2.png" } } }
    }
  },

  {
    sys: { id: 7 },

    fields: {
      title: "canon Eos 30 photo camera",
      price: 31000,
      company: "canon",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-7.png" } } }
    }
  },
  {
    sys: { id: 8 },

    fields: {
      title: "nikon D 3100 photo camera",
      price: 29000,
      company: "nikon",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-8.png" } } }
    }
  },
  {
    sys: { id: 9 },

    fields: {
      title: "htc 10 - white",
      price: 21000,
      company: "htc",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-3.png" } } }
    }
  },
  
  {
    sys: { id: 10 },

    fields: {
      title: "Microsoft Surface pro",
      price: 63000,
      company: "Microsoft",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-10.png" } } }
    }
  },
  {
    sys: { id: 11 },

    fields: {
      title: "Hp Laptop",
      price: 41000,
      company: "Hp",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,
      image: { fields: { file: { url: "img/product-11.png" } } }
    }
  },
  {
    sys: { id: 12 },

    fields: {
      title: "Microsoft Surface Pro 4",
      price: 68000,
      company: "Microsoft",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,
      image: { fields: { file: { url: "img/product-12.png" } } }
    }
  }
];
